export default __webpack_public_path__ + "static/media/profile.990e269b.svg";